export const menuData = [
  { title: 'Home', link: '/' },
  { title: 'Latest Stock', link: '/latest-stock' },
  { title: 'Locate-a-Car', link: '/locate-A-car' },
  { title: 'Testimonials', link: '/testimonials' },
  { title: 'Benefits', link: '/benefits' },
  { title: 'Blog', link: '/blog' },
];
